import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, mergeMap } from 'rxjs';
import { Authentication } from './authentication.service';
import { ErrorHandlingService } from './error-handling.service';
import * as uuid from 'uuid';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  correlationId = uuid.v4();
  constructor(
    private authService: Authentication,
    private errorHandlingService: ErrorHandlingService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('/auth/token') || request.url.includes('/account/token') || request.url.includes('/account/reset')) {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          return this.errorHandlingService.handleError(error, error.url);
        }),
      );
    } else if (this.authService.isTokenValid()) {
      request = this.addAuthorizationHeader(request);
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          return this.errorHandlingService.handleError(error, error.url);
        }),
      );
    } else {
      return this.refreshTokenAndRetry(request, next);
    }
  }

  private addAuthorizationHeader(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.authService.getAccessToken();
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-Correlation-ID': this.correlationId,
      },
    });
  }

  private refreshTokenAndRetry(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.authService.whitelistedUrls()) {
      return this.authService.refreshTokenAndRetry().pipe(
        mergeMap((response) => {
          const newAccessToken = response.access_token;
          const newRefreshToken = response.refresh_token;
          localStorage.setItem('access_token_automap', newAccessToken);
          localStorage.setItem('refresh_token_automap', newRefreshToken);
          this.correlationId = uuid.v4();
          request = this.addAuthorizationHeader(request);
          return next.handle(request);
        }),
        catchError((error: HttpErrorResponse) => {
          return this.errorHandlingService.handleError(error, error.url);
        }),
      );
    } else {
      return next.handle(request.clone());
    }
  }
}
